import Head from 'next/head';
import React from 'react';
import { b2cPagesService } from '@clubmed/utils';
import { getUrl } from 'Components/utils/media-server';
import { useResponsive } from 'Components/utils/responsive/ResponsiveContext';
import { IMMERSIVE, PRODUCT_IMMERSIVE } from 'Cms/constants';
import type { LineProps } from 'Components/frameworks/line/Line';
import 'Components/frameworks/line/Line';
const { PAGE_TYPES } = b2cPagesService;
type Props = {
  description: string;
  immersiveUrl?: string;
  lines?: ReadonlyArray<LineProps>;
  pageType?: string;
  title: string;
  url: string;
};
export const FacebookAndTwitterSeoHeaderMeta = ({
  description,
  immersiveUrl = '',
  lines,
  pageType = '',
  title,
  url,
}: Props) => {
  const { isDesktop } = useResponsive();

  /**
   * Format immersive url for SEO
   * @param {string} urlImmersive The url to format
   * @returns The url formatted
   */
  const getImmersiveUrl = (urlImmersive) =>
    getUrl({
      url: urlImmersive,
      width: 1200,
      height: 'auto',
      format: '_AUTOFORMAT_',
      quality: 70,
      transform: 'resize',
    });

  const getFirstImmersiveUrl = (allLines) => {
    let immersives = [];

    const collectFn = (line) => {
      const backgroundURL = isDesktop
        ? line.props.backgroundURLDesktop
        : line.props.backgroundURLMobile;
      immersives =
        line.name === IMMERSIVE ? [...immersives, getImmersiveUrl(backgroundURL)] : immersives;
      immersives =
        line.name === PRODUCT_IMMERSIVE && !!line.props.media?.photos
          ? [...immersives, ...line.props.media.photos.map((p) => getImmersiveUrl(p.url))]
          : immersives;
      (line.props.lines || []).forEach(collectFn);
    };

    allLines.forEach(collectFn);
    return immersives && immersives.length > 0 ? immersives[0] : '';
  };

  const immersiveUrlFromLines = lines && lines.length > 0 ? getFirstImmersiveUrl(lines) : '';
  return (
    <Head>
      {/* Facebook meta */}
      <meta property="og:type" content="website" />
      {pageType !== PAGE_TYPES.CRUISE &&
        pageType !== PAGE_TYPES.RESORT &&
        pageType !== PAGE_TYPES.RESORT_MICE && <meta property="og:title" content={title} />}
      {pageType !== PAGE_TYPES.CRUISE && <meta property="og:description" content={description} />}
      <meta property="og:image" content={immersiveUrl || immersiveUrlFromLines} />
      <meta property="og:url" content={url} />
      {/* Twitter meta */}
      <meta name="twitter:card" content="summary_large_image" />
      {pageType !== PAGE_TYPES.CRUISE &&
        pageType !== PAGE_TYPES.RESORT &&
        pageType !== PAGE_TYPES.RESORT_MICE && <meta name="twitter:title" content={title} />}
      {pageType !== PAGE_TYPES.CRUISE && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={immersiveUrl || immersiveUrlFromLines} />
      <meta name="twitter:url" content={url} />
    </Head>
  );
};
